import React, { useState } from "react";
import { Link } from "react-router-dom";
import { createSampleLeague } from "../lib/api";

/**
 * SampleLeagueCta — friendly nudge shown on the dashboard when the user
 * is in zero leagues. Spawns a demo league with 3 bot teams via
 * POST /api/onboarding/sample-league. Dismissable.
 */
export function SampleLeagueCta({ myLeaguesCount, onToast }) {
  const [busy, setBusy] = useState(false);
  const [created, setCreated] = useState(null);
  const [dismissed, setDismissed] = useState(false);
  if (myLeaguesCount > 0 || dismissed) return null;

  const seed = async () => {
    setBusy(true);
    try {
      const r = await createSampleLeague();
      setCreated(r.league);
      onToast?.(r.created ? "🤖 Demo league spawned with 3 bot teams!" : "Demo league re-opened.");
    } catch (e) {
      onToast?.(e?.response?.data?.detail || "Couldn't create the demo league.");
    } finally { setBusy(false); }
  };

  return (
    <div data-testid="sample-league-cta"
         className="relative rounded-2xl border border-[#14b8a6]/40 bg-[#14b8a6]/8 p-4">
      <button type="button" onClick={() => setDismissed(true)}
              data-testid="sample-league-dismiss"
              className="absolute top-2 right-2 text-white/40 hover:text-white text-sm">
        <i className="fas fa-xmark" />
      </button>
      <p className="text-[10px] tracking-[3px] text-[#14b8a6] font-bold">
        <i className="fas fa-robot mr-1" />NEW HERE?
      </p>
      <h3 className="font-display text-xl text-white mt-1">Spawn a demo league</h3>
      <p className="text-[12px] text-white/65 mt-1">
        We'll seed a starter league with 3 bot teams so you can practice
        scheduling, scoring, and team chat without waiting for real opponents.
      </p>
      {created ? (
        <Link to={`/leagues/${created.slug}`}
              data-testid="sample-league-open"
              className="inline-block mt-3 text-[11px] tracking-widest px-4 py-2 rounded-xl btn-neon">
          <i className="fas fa-arrow-right mr-1" />OPEN '{created.name}'
        </Link>
      ) : (
        <button type="button" onClick={seed} disabled={busy}
                data-testid="sample-league-spawn"
                className="mt-3 text-[11px] tracking-widest px-4 py-2 rounded-xl btn-neon disabled:opacity-50">
          {busy ? "SPAWNING…" : <><i className="fas fa-bolt mr-1" />SPAWN DEMO LEAGUE</>}
        </button>
      )}
    </div>
  );
}
